import React, { FC, ReactNode } from "react";
import classNames from "classnames";
import { UseFormRegister } from "react-hook-form";

import { SvgIcon } from "../../../SvgIcon/SvgIcon";
import { he } from "date-fns/locale";

export type CheckBoxProps = {
  label: string;
  heading?: string;
  name: string;
  error?: any;
  register: UseFormRegister<any>;
  required?: boolean;
  onClick?: () => void;
  backgroundColor?: string;
  disabled?: boolean;
};

export const CheckBox: FC<CheckBoxProps> = ({
  label,
  heading,
  name,
  register,
  error,
  required = false,
  children,
  onClick,
  backgroundColor,
  disabled,
}) => {
  const id = `input-${name}`;
  const hasError = error != undefined;
  return (
    <label
      className={classNames(
        "position-relative booking-narrow-item mt-2 input__checkboxContainer",
        {
          "input__checkboxContainer--error": hasError,
        }
      )}
    >
      <span>{children ?? label}</span>
      <input
        {...register(name)}
        id={id}
        name={name}
        type="checkbox"
        required={required}
        aria-describedby={"errorId-" + id}
        className={classNames("input__checkbox", {
          "input__checkbox--withChildren": children,
        })}
        onClick={onClick}
        disabled={disabled}
      />
      <div
        className="input__checkboxMimic"
        style={{ background: backgroundColor }}
      >
        <SvgIcon iconName="ic-check" />
      </div>
      {error && error.message && (
        <div
          className={classNames("mt-1", {
            "input__support--error": hasError,
          })}
        >
          <p id={"errorId-" + id} className="fs-6 m-0 input__supportText">
            {error && error.message}
          </p>
        </div>
      )}
      {heading && (
        <span className="position-absolute select__label select__label--focus">
          {heading}
        </span>
      )}
    </label>
  );
};
